import React from 'react';
import { Tag, Empty } from 'antd';
import styles from './TimeRangeList.module.scss';

const { CheckableTag } = Tag;

const TimeRange = ({ range, checked, onChange, ...props }) => {
  return (
    <CheckableTag
      {...props}
      className={styles.range}
      checked={checked}
      onChange={checked ? undefined : () => onChange(range)}
    >
      {range.text}
    </CheckableTag>
  );
};

const TimeRangeList = ({ ranges, onChange, currentRange }) => {
  return ranges?.length ? (
    <ul className={styles.root}>
      {ranges.map((range) => (
        <li key={range.id}>
          <TimeRange
            range={range}
            onChange={onChange}
            checked={currentRange?.id === range.id}
          />
        </li>
      ))}
    </ul>
  ) : (
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description="Нет свободного времени"
      className={styles.empty}
    />
  );
};

export default TimeRangeList;
